<script setup lang="ts">
import { useAuthUser } from '@/helpers/globals';

const authUser = useAuthUser();
</script>

<template>
    <h4 class="ktg-title-04">{{ $t('my_profile') }}</h4>
    <p class="ktg-body-small mt-2rem mb-1rem" v-html="$t('useraccount_settings_profil_info_text')"></p>
    <div class="mb-3rem">
        <ktg-link leading-icon="open-new-tab" href="https://agov.ch/me" target="_blank">{{
            $t('zu_meinem_agov_konto')
        }}</ktg-link>
    </div>
    <div class="useraccountprofilecontainer p-3rem">
        <div class="element">
            <h5 class="ktg-title-05">{{ $t('my_profile') }}</h5>
        </div>
        <ktg-line></ktg-line>
        <div class="element">
            <div class="flex flex-grow-1">
                <div class="ktg-subtitle-02">{{ $t('persoenliche_daten_agov') }}</div>
            </div>

            <div class="ua_grid mt-2rem ktg-body-small" role="table">
                <div class="label ktg-eyebrow" role="cell">
                    {{ $t('name') }}
                </div>
                <div class="value" role="cell">{{ authUser?.vorname }} {{ authUser?.nachname }}</div>

                <div class="label ktg-eyebrow" role="cell">
                    {{ $t('geburtsdatum') }}
                </div>
                <div class="value" role="cell">
                    {{
                        authUser?.date_of_birth && authUser.date_of_birth.isValid()
                            ? authUser.date_of_birth.format('DD.MM.YYYY')
                            : '-'
                    }}
                </div>

                <div class="label ktg-eyebrow" role="cell">
                    {{ $t('email_adresse') }}
                </div>
                <div class="value" role="cell">
                    {{ authUser?.email }}
                </div>
            </div>
        </div>
        <ktg-line></ktg-line>
    </div>
</template>
<style scoped lang="scss">
.useraccountprofilecontainer {
    background-color: var(--ktg-color-neutral-01);

    .element {
        background-color: white;
        padding: 20px;
        padding-top: 40px;
    }
}

.ua_grid {
    display: grid;
    grid-template-columns: 180px 1fr;
    gap: 1em;

    .ua-left {
        width: 180px;
    }
}
</style>
